import Path from '@leverege/path'

export default class LocalUserSettingsDelegate {
  constructor( opts ) {
    this.options = opts
    this.state = {}
  }

  getScope( state, path, opts ) {
    return 'local'
  }

  getProfileScope( state, profile, path, opts ) {
    return 'local'
  }

  // interface functions for current
  get( state, path, opts ) {
    return Path( [ 'state', 'values', path ] ).get( this.state, null )
  }

  getProfile( state, profile, path, opts ) {
    return Path( [ 'state', 'profiles', profile, path ] ).get( this.state, null )
  }

  set( path, value ) {
    return Path( [ 'state', 'values', path ] ).set( this.state, value )
  }

  reset( path ) {
    return Path( [ 'state', 'values', path ] ).delete( this.state )
  }

  // current version stuff
  getVersion( state, path, version, opts ) {
    return Path( [ 'state', 'versions', path, version ] ).get( this.state, null )
  }

  getVersions( state, path, opts ) {
    const v = Path( [ 'state', 'versions', path ] ).get( this.state, {} )
    const items = Object.entries( v )

    return {
      items : items.map( ( [ path, value ] ) => ( { path, value } ) ),
      count : items.length,
      total : items.length
    }
  }

  setVersion( path, version, value, opts ) {
    return Path( [ 'state', 'versions', path, version ] ).set( this.state, value )
  }

  renameVersion( path, oldVersionName, newVersionName, opts ) {
    const v = Path( [ 'state', 'versions', path, oldVersionName ] ).get( this.state, null )
    Path( [ 'state', 'versions', path, oldVersionName ] ).delete( this.state )
    return Path( [ 'state', 'versions', path, newVersionName ] ).set( this.state, v )
  }

  resetVersion( path, version ) {
    Path( [ 'state', 'versions', path, version ] ).delete( this.state )
  }
  // end current version stuff
  // end current

  // interface functions for setting a specific shared profile
  getSharedProfile( state, profile, path, opts ) {
    return Path( [ 'state', 'profiles', profile, path ] ).get( this.state, null )
  }

  setSharedProfile( profile, path, value, opts ) {
    return Path( [ 'state', 'profiles', profile, path ] ).set( this.state, value )
  }

  getSharedProfiles() {
    return null
  }

  resetSharedProfile( profile, path, opts ) {
    return Path( [ 'state', 'profiles', profile, path ] ).delete( this.state )
  }
  // end interface functions for a specific profile

  // shared version stuff
  getSharedVersion( state, path, version, opts ) {
    return Path( [ 'state', 'versions', path, version ] ).get( this.state, null )
  }

  getSharedVersions( state, path, opts ) {
    const v = Path( [ 'state', 'versions', path ] ).get( this.state, {} )
    const items = Object.entries( v )

    return {
      items : items.map( ( [ path, value ] ) => ( { path, value } ) ),
      count : items.length,
      total : items.length
    }
  }

  setSharedVersion( path, version, value, opts ) {
    return Path( [ 'state', 'versions', path, version ] ).get( this.state, value )
  }

  renameSharedVersion( path, oldVersionName, newVersionName, opts ) {
    const v = Path( [ 'state', 'versions', path, oldVersionName ] ).get( this.state, null )
    Path( [ 'state', 'versions', path, oldVersionName ] ).delete( this.state )
    return Path( [ 'state', 'versions', path, newVersionName ] ).set( this.state, v )
  }

  resetSharedVersion( path, version ) {
    return Path( [ 'state', 'versions', path, version ] ).delete( this.state )
  }
  // end shared version stuff

  // interface functions for setting a user's specific profile
  getUserProfile( state, profile, path, opts ) {
    return Path( [ 'state', 'profiles', profile, path ] ).get( this.state, null )
  }

  setUserProfile( profile, path, value ) {
    return Path( [ 'state', 'profiles', profile, path ] ).set( this.state, value )
  }

  getUserProfiles() {
    return null
  }

  resetUserProfile( profile, path ) {
    return Path( [ 'state', 'profiles', profile, path ] ).delete( this.state )
  }
  // end interface functions for a user's specific profile

  // user version stuff
  getUserVersion( state, path, version, opts ) {
    return Path( [ 'state', 'versions', path, version ] ).get( this.state, null )
  }

  getUserVersions( state, path, opts ) {
    const v = Path( [ 'state', 'versions', path ] ).get( this.state, {} )
    const items = Object.entries( v )

    return {
      items : items.map( ( [ path, value ] ) => ( { path, value } ) ),
      count : items.length,
      total : items.length
    }
  }

  setUserVersion( path, version, value, opts ) {
    return Path( [ 'state', 'versions', path, version ] ).get( this.state, value )
  }

  renameUserVersion( path, oldVersionName, newVersionName, opts ) {
    const v = Path( [ 'state', 'versions', path, oldVersionName ] ).get( this.state, null )
    Path( [ 'state', 'versions', path, oldVersionName ] ).delete( this.state )
    return Path( [ 'state', 'versions', path, newVersionName ] ).set( this.state, v )
  }

  resetUserVersion( path, version ) {
    return Path( [ 'state', 'versions', path, version ] ).delete( this.state )
  }
  // end user version stuff
}
